import { useCallback, useEffect, useState } from "react"

export function useMediaBlobUrl() {
	const [blobUrls, setBlobUrls] = useState<Map<string, string>>(new Map())

	const loadMediaAsBlob = useCallback(
		async (url: string): Promise<string> => {
			if (blobUrls.has(url)) {
				return blobUrls.get(url)!
			}

			try {
				const response = await fetch(url)
				const blob = await response.blob()
				const blobUrl = URL.createObjectURL(blob)
				setBlobUrls((prev) => new Map(prev).set(url, blobUrl))
				return blobUrl
			} catch (error) {
				console.error("Failed to load media as blob:", error)
				return url
			}
		},
		[blobUrls],
	)

	useEffect(() => {
		return () => {
			for (const blobUrl of blobUrls.values()) {
				URL.revokeObjectURL(blobUrl)
			}
		}
	}, [blobUrls])

	return { loadMediaAsBlob }
}
